import {
    GET_PREFERRED_PROVIDER_START,
    GET_PREFERRED_PROVIDER_SUCCESS,
    GET_PREFERRED_PROVIDER_ERROR
} from '../../constants';

import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { getServiceProvider as query } from '../../lib/graphql';

// Client "see provider list": fetch the SAME eligible-worker list as the mobile app (calendar-aware,
// each with their own price). Stores into state.booking.preferredProviders (reuses the existing
// reducer + the PreferredProviderForm list render).
export const getServiceProvider = (variables) => {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: GET_PREFERRED_PROVIDER_START,
                payload: { loading: true, preferredProviders: [] }
            });

            const { data } = await client.query({
                query,
                variables,
                fetchPolicy: 'network-only'
            });

            const isAvailableProvider = data?.getServiceProvider?.status === 200;
            dispatch({
                type: isAvailableProvider ? GET_PREFERRED_PROVIDER_SUCCESS : GET_PREFERRED_PROVIDER_ERROR,
                payload: {
                    loading: false,
                    preferredProviders: data?.getServiceProvider?.result || []
                }
            });

            if (!isAvailableProvider) {
                showToaster({ messageId: 'errorMessage', requestContent: data?.getServiceProvider?.errorMessage, toasterType: 'error' });
            }
            return true;
        } catch (error) {
            showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
            return false;
        }
    };
};
